import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, LayoutGrid, Map, ShoppingCart, User, Tag } from 'lucide-react';
import { useAuth } from '../contexts/AuthContext';
import { useLanguage } from '../contexts/LanguageContext';

// Persistent mobile bottom tab bar (hidden on md+). Gives thumb-reach access
// to the core marketplace flows on phones.
export default function BottomNav() {
  const { pathname } = useLocation();
  const { user } = useAuth();
  const { tr } = useLanguage();

  const items = [
    { to: '/', icon: Home, label: tr('Sākums', 'Home', 'Главная'), match: (p) => p === '/', testid: 'bottomnav-home' },
    { to: '/catalog', icon: LayoutGrid, label: tr('Katalogs', 'Catalog', 'Каталог'), match: (p) => p.startsWith('/catalog'), testid: 'bottomnav-catalog' },
    { to: '/sludinajumi', icon: Tag, label: tr('Sludinājumi', 'Ads', 'Объявл.'), match: (p) => p.startsWith('/sludinaj'), testid: 'bottomnav-classifieds' },
    { to: '/karte', icon: Map, label: tr('Karte', 'Map', 'Карта'), match: (p) => p.startsWith('/karte') || p.startsWith('/map'), testid: 'bottomnav-map' },
    { to: '/cart', icon: ShoppingCart, label: tr('Grozs', 'Cart', 'Корзина'), match: (p) => p.startsWith('/cart'), testid: 'bottomnav-cart' },
    { to: user ? `/lietotajs/${user._id || user.id}` : '/login', icon: User, label: tr('Profils', 'Profile', 'Профиль'), match: (p) => p.startsWith('/lietotajs/') || p.startsWith('/login'), testid: 'bottomnav-profile' },
  ];

  return (
    <nav
      className="md:hidden fixed bottom-0 inset-x-0 z-50 bg-white/95 backdrop-blur-xl border-t border-black/10"
      style={{ paddingBottom: 'env(safe-area-inset-bottom)' }}
      data-testid="mobile-bottom-nav"
    >
      <div className="flex items-stretch justify-around">
        {items.map((it) => {
          const Icon = it.icon;
          const active = it.match(pathname);
          return (
            <Link
              key={it.testid}
              to={it.to}
              aria-current={active ? 'page' : undefined}
              className={`flex-1 flex flex-col items-center justify-center gap-0.5 py-2 min-h-[56px] transition-colors active:scale-95 ${active ? 'text-[#D97736]' : 'text-[#5C5C5C]'}`}
              data-testid={it.testid}
            >
              <Icon className="w-[22px] h-[22px]" strokeWidth={active ? 2.4 : 1.9} />
              <span className="text-[10px] font-medium leading-none">{it.label}</span>
            </Link>
          );
        })}
      </div>
    </nav>
  );
}
